import { render, staticRenderFns } from "./TerritoryContactsListCommunication.vue?vue&type=template&id=44f920a7&scoped=true&"
import script from "./TerritoryContactsListCommunication.vue?vue&type=script&lang=js&"
export * from "./TerritoryContactsListCommunication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f920a7",
  null
  
)

export default component.exports